import { render, staticRenderFns } from "./CiCounter.vue?vue&type=template&id=edf7a99c&scoped=true&"
import script from "./CiCounter.vue?vue&type=script&lang=js&"
export * from "./CiCounter.vue?vue&type=script&lang=js&"
import style0 from "./CiCounter.vue?vue&type=style&index=0&id=edf7a99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7a99c",
  null
  
)

component.options.__file = "CiCounter.vue"
export default component.exports